import React, { useEffect, useState } from "react";
import styles from "./drSupport.module.css";
import axios from "axios";
import { Check } from "react-bootstrap-icons";
import { Icon } from "antd";
import cookie from "react-cookies";

const DrSupport = (props) => {
  let doctor_id = props.match.params.d_id;
  const [login, setLogin] = useState(false);
  const [fullName, setFullName] = useState("");
  const [supportLoading, setSupportLoading] = useState(false);
  const [followOk, setFollowOk] = useState(false);

  useEffect(() => {
    let nobat_cookie = cookie.loadAll();
    if (nobat_cookie.nuserRemember) {
      loginAction();
    }

    getPageDrName(doctor_id);
  }, []);

  const loginAction = async () => {
    const formData = new FormData();
    formData.set("dr_id", doctor_id);
    let config = {
      method: "post",
      url: window.server + "/doctor/auth/check",
      data: formData,
      headers: {
        "Content-Type": "application/json",
      },
    };
    try {
      let response = await axios(config);
      let res = response.data;
      setLogin(res.login);
      setFollowOk(res.follow);
    } catch (error) {
      console.log(error);
    }
  };

  const getPageDrName = async (d_id) => {
    const formData = new FormData();
    formData.set("dr_id", d_id);
    let config = {
      method: "post",
      data: formData,
      url: window.server + "/doctor/name",
      headers: {
        "Content-Type": "application/json",
      },
    };
    try {
      let response = await axios(config);
      let res = response.data;
      setFullName(res.name);
    } catch (error) {
      console.log(error);
    }
  };

  const followAction = async (d_id) => {
    setSupportLoading(true);

    const formData = new FormData();
    formData.set("follow_dr", d_id);
    let config = {
      method: "post",
      data: formData,
      url: window.appServer + "/doctor/supporter/follow",
      headers: {
        "Content-Type": "application/json",
      },
    };
    try {
      let response = await axios(config);
      let res = response.data;
      setSupportLoading(false);
      setFollowOk(!followOk);
    } catch (error) {
      setSupportLoading(false);
      console.log(error);
    }
  };

  return (
    <div className={styles.main}>
      {login && (
        <div
          className={`${followOk ? styles.follow_ok_box : styles.follow_btn} ${
            supportLoading ? "follow_loading" : ""
          } ${followOk ? "follow_ok" : ""}`}
          onClick={() => followAction(doctor_id)}
        >
          {supportLoading ? (
            <Icon type="loading" />
          ) : followOk ? (
            <span>
              {" "}
              <Check /> حمایت میکنم
            </span>
          ) : (
            <span> حمایت </span>
          )}
        </div>
      )}
    </div>
  );
};

export default DrSupport;
